import { useQuery } from 'react-query';

import type { User } from '../types';

type UseUsersDetailsHandler = {
  data: Array<User>;
  error: string | null;
  isLoading: boolean;
};
const useUsersDetails = (usersIds: Array<number>): UseUsersDetailsHandler => {
  const { data, error, isLoading } = useQuery<Array<User>, string>(
    ['users-details', usersIds],
    async () => {
      const responses = usersIds.map(async (userId: number) => {
        const response = await fetch(
          `/api/organisation/users/${userId}/details/`,
        );
        if (response.ok) return response.json();
        throw new Error('Something went wrong');
      });

      return Promise.all(responses);
    },
  );
  return { data: data ?? [], error, isLoading };
};

export default useUsersDetails;
